import { rpcClient } from "@/api/WebsocketClient"
import SWR, { Call } from "@/api/SWR"
import { reactive } from "@vue/reactivity"
import SortAndFilterUtil from "@/util/SortAndFilterUtil"
import Project from '@/model/Project';
import { projectStore } from '@/store/ProjectStore';

export default class GeneratedProjectTagServiceApi {

    cache: Map<string, Call<any>> = new Map<string, Call<any>>()

    constructor() {
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.apis.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    clearState() {
        this.cache = new Map<string, Call<any>>()
    }

    get connected(): boolean {
        return rpcClient.state.connected
    }

    _removeProjectTag(id: number, tag: string): Promise<number> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('removeProjectTag', rpcParams, false).then((data: any) => {
            const model = Object.assign(new Project(), data)
            projectStore.removeProject(id)
            projectStore.addOrReplaceProject(model)
            return model.id
        })
    }

    _addProjectTag(id: number, tag: string): Promise<number> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('addProjectTag', rpcParams, false).then((data: any) => {
            const model = Object.assign(new Project(), data)
            projectStore.removeProject(id)
            projectStore.addOrReplaceProject(model)
            return model.id
        })
    }

    getProjects(pageIndex?: number, pageSize?: number): Project[] {
        let projects: Project[] = [...projectStore.state.projects.values()]
        
        
        if (pageSize !== null && pageSize !== undefined) {
            projects = projects.slice((pageIndex || 0) * pageSize, ((pageIndex || 0) + 1) * pageSize)
        }
        return projects
    }

    getProject(id: number): Project | undefined {
        return projectStore.state.projects.get(id)
    }
}
